/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Message } from './Message';
import {
    MessageFromJSON,
    MessageFromJSONTyped,
    MessageToJSON,
} from './Message';

/**
 * 
 * @export
 * @interface ControlMethodNotAllowedError
 */
export interface ControlMethodNotAllowedError {
    /**
     * 
     * @type {number}
     * @memberof ControlMethodNotAllowedError
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof ControlMethodNotAllowedError
     */
    title: string;
    /**
     * 
     * @type {Message}
     * @memberof ControlMethodNotAllowedError
     */
    message: Message;
}

/**
 * Check if a given object implements the ControlMethodNotAllowedError interface.
 */
export function instanceOfControlMethodNotAllowedError(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "message" in value;

    return isInstance;
}

export function ControlMethodNotAllowedErrorFromJSON(json: any): ControlMethodNotAllowedError {
    return ControlMethodNotAllowedErrorFromJSONTyped(json, false);
}

export function ControlMethodNotAllowedErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlMethodNotAllowedError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'title': json['title'],
        'message': MessageFromJSON(json['message']),
    };
}

export function ControlMethodNotAllowedErrorToJSON(value?: ControlMethodNotAllowedError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'title': value.title,
        'message': MessageToJSON(value.message),
    };
}

